<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('action.calcExpectHandOver')]"></breadcrumb>
    </div>
    <div class="search center">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-autocomplete
            size="small"
            v-model.trim="searchForm.productNo"
            :fetch-suggestions="querySearchProductNo"
            :trigger-on-focus="false"
            style="width: 100%"
            @select="handleSelectProductNo"
            :placeholder="$t('product.productNo')"
          >
            <template slot-scope="{ item }">
              <div class="name">{{ item.productNo }}</div>
              <span class="addr">{{ item.productNoAlias }}</span>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item :prop="'mesCycle'">
          <el-input
            size="small"
            v-model.trim="searchForm.mesCycle"
            :placeholder="$t('rules.mustFillSimple', [$t('product.mesCycle')])"
          />
        </el-form-item>
        <el-form-item :prop="'quantity'">
          <el-input
            size="small"
            v-model.trim="searchForm.quantity"
            :placeholder="$t('rules.mustFillSimple', [$t('text.quantity')])"
          />
        </el-form-item>
        <el-form-item>
          <el-radio-group v-model="searchForm.type" size="small">
            <el-radio-button label="bulk">{{
              $t("dealOrderTypes.bulk")
            }}</el-radio-button>
            <el-radio-button label="custom">{{
              $t("dealOrderTypes.custom")
            }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <div class="mgt10">
          <el-button type="primary" size="small" native-type="submit"
            >查询</el-button
          >
        </div>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <div
        class="font18 center"
        v-if="searchForm.mesCycle != null && searchForm.mesCycle != ''"
      >
        本产品生产周期 {{ searchForm.mesCycle }} 天
      </div>
      <div v-if="records.length != 0">
        <div v-for="(record, index) of records" :key="index" class="mgb10">
          <div style="height: 50px; line-height: 50px" @click="expend(index)">
            <span>
              <i
                :class="
                  record.showDF == true
                    ? 'el-icon-arrow-down'
                    : 'el-icon-arrow-right'
                "
                style="font-size: 18px"
                class="mgr10"
              />
            </span>
            <span class="font20 mgr10">{{ record.factoryName }}</span>
            <span class="mgr10">
              <span class="mgr10">
                {{ $t("factory.bulkCapacity") }}：{{ record.bulkCapacity }}
              </span>
              <span class="mgr10">
                {{ $t("factory.customCapacity") }}：{{ record.customCapacity }}
              </span>
            </span>
          </div>
          <div v-if="record.showDF" class="pd20">
            <div v-if="record.success == true">
              <div class="mgb20">
                未开工订单所需产能：
                <span class="mgr10">
                  {{ $t("dealOrderTypes.bulk") }} {{ record.bulkQty }} 件
                </span>
                {{ $t("dealOrderTypes.custom") }} {{ record.customQty }} 件
              </div>
              <div class="mgb20">
                预计上线生产日期：{{ record.earlyStartDate }}， 其中休假：<span
                  v-if="record.restDates.length != 0"
                >
                  {{ record.restDates.join("，") }}
                </span>
                <span v-else>无</span>
              </div>
              <div class="mgb20">
                上线后预计生产完成日期：{{
                  record.earlyEndDate
                }}，其中休假：<span v-if="record.restEndDates.length != 0">
                  {{ record.restEndDates.join("，") }}
                </span>
                <span v-else>无</span>
              </div>
            </div>
            <div v-else class="grey">
              {{ record.reason }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="noData"></div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Product from "@/api/product.js";
import OrderMes from "@/api/orderMes.js";

export default {
  mixins: [page, table.search],
  components: {},
  data() {
    return {
      Util: Util,
      searchForm: {
        productNo: null,
        mesCycle: null,
        quantity: null,
        type: "bulk",
      },
      records: [],
      searchFormDF: false,
      loading: false,
    };
  },
  created() {
    const self = this;
  },
  methods: {
    expend(index) {
      this.records[index].showDF = !this.records[index].showDF;
    },
    search() {
      const self = this;
      if (self.searchForm.mesCycle == null || self.searchForm.mesCycle == "") {
        this.$message({
          message: self.$t("rules.required", [self.$t("product.mesCycle")]),
          type: "warning",
        });
        return;
      }
      if (self.searchForm.quantity == null || self.searchForm.quantity == "") {
        this.$message({
          message: self.$t("rules.required", [self.$t("text.quantity")]),
          type: "warning",
        });
        return;
      }
      self.records = [];
      self.loading = true;
      OrderMes.calcExpectHandOver(self.searchForm).then(function (res) {
        if (res.status == 200) {
          if (res.data.length != 0) {
            self.records = res.data;
            for (const record of self.records) {
              Vue.set(record, "showDF", true);
            }
          }
          self.searchFormDF = true;
        } else {
          self.sysError();
        }
        self.loading = false;
      });
    },
    computeHoliday(nonWork, type) {
      if (nonWork == null) {
        return [];
      }
      const nonWorkObj = JSON.parse(nonWork);
      if (type == "yearHoliday") {
        if (nonWorkObj.yearHoliday.open == true) {
          return nonWorkObj.yearHoliday.list;
        }
        return [];
      }
      if (type == "monthHoliday") {
        if (nonWorkObj.monthHoliday.open == true) {
          return nonWorkObj.monthHoliday.list;
        }
        return [];
      }
      if (type == "weekHoliday") {
        if (nonWorkObj.weekHoliday.open == true) {
          return nonWorkObj.weekHoliday.list;
        }
        return [];
      }
    },

    // 货号
    querySearchProductNo(queryString, cb) {
      const self = this;
      //
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Product.vagueFindByProductNo({ productNo: queryString }).then(function (
        res
      ) {
        self.products = res.data;
        if (self.products.length !== 0) {
          for (const p of self.products) {
            Vue.set(p, "value", p.productNo);
          }
        }
        cb(self.products);
      });
    },
    handleSelectProductNo(item) {
      const self = this;
      self.searchForm.productNo = item.productNo;
      self.searchForm.mesCycle = item.mesCycle;
    },
  },
};
</script>
<style scoped>
</style>
